import { useThemeMode } from "@shared-components/global/theme-provider";
import { Label } from "@shared-components/shadcn/label";
import { Switch } from "@shared-components/shadcn/switch";

export const DarkModeSwitch = () => {
  const { themeMode, toggleThemeMode } = useThemeMode();

  return (
    <div className="flex items-center space-x-2 px-2 py-1">
      <Switch
        checked={themeMode == "dark"}
        onCheckedChange={() => toggleThemeMode()}
        id="dark-mode"
      />
      <Label htmlFor="dark-mode">{"Dark mode"}</Label>
    </div>
  );
};
